import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isArrayIncludes',
  standalone: true,
  pure: true,
})
export class IsArrayIncludesPipe implements PipeTransform {
  transform(values: string, currentValue: string): boolean {
    const valuesArray = values.split('|');

    return valuesArray.includes(currentValue);
  }
}
